import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthStore } from '../store/auth.store';
import { NotificationService } from '../services/notification.service';
import { UserRole } from '../models/user.model';

export const roleGuard =
  (allowedRoles: UserRole[]): CanActivateFn =>
  () => {
    const auth = inject(AuthStore);
    const router = inject(Router);
    const notification = inject(NotificationService);

    return auth.loadSession().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated && auth.hasRole(allowedRoles)) {
          return true;
        }

        notification.showError("You don't have permission to access that page.");
        return router.createUrlTree(['/dashboard']);
      })
    );
  };
